import React, { Component } from 'react';
import { hasRole, isRole } from '../../services';

class Role extends Component {
    render() {
        const { is, has, not } = this.props;
        let result = false;
        let roles  = (has ? has :(is ? is : '')).split(' ');

        for (let role of roles) {
            result = result || (is ? isRole(role) : hasRole(role));
        }

        if(not){
            result = !result;
        }

        return result ? this.props.children : '';
    }
}

export default Role;
